import { makeFetchStateReducer } from "seneca-common/utils/apiStates";

import {
  ENTITY_NAME,
  ACTIONS_NAMESPACE,
  META_IDS_FIELD_NAME
} from "../../../consts";

const metaReducer = makeFetchStateReducer({
  name: ENTITY_NAME,
  path: ACTIONS_NAMESPACE,
  idFieldName: META_IDS_FIELD_NAME
});

export default metaReducer;
